import React, { useState, useEffect } from "react";
import { Modal, Icon, Grid } from "semantic-ui-react";
import { DownloadMetadataModal } from "./DownloadMetadataModal";
import { DownloadFilteredMetadataModal } from "./DownloadFilteredMetadataModal";
import BulkMetadataUpdateModal from "./BulkMetadataUpdateModal";
import { ThinDivider } from "../../../Dashboards/Panel/util";
import { searchDevicesFilters } from "../../../../../BytebeamClient";
import { StyledButtonWithBorder } from "../Devices";

type BulkMetadataOperationsModalProps = {
  readonly isOpen: boolean;
  readonly close: (...args: any[]) => any;
  readonly setLoading: (...args: any[]) => void;
  readonly getDevicesFilters: () => searchDevicesFilters;
  readonly selectedDevices: string[];
  readonly refreshDevices: (inLoop?: boolean) => Promise<void>;
  readonly isRefreshPaused: boolean;
};

function BulkMetadataOperationsModal(props: BulkMetadataOperationsModalProps) {
  const {
    isOpen,
    close,
    setLoading,
    getDevicesFilters,
    selectedDevices,
    refreshDevices,
    isRefreshPaused,
  } = props;
  const [renderBulkDownloadMetadata, setRenderBulkDownloadMetadata] =
    useState(false);
  const [renderFilteredDownloadMetadata, setRenderFilteredDownloadMetadata] =
    useState(false);
  const [renderBulkUpdateMetadata, setRenderBulkUpdateMetadata] =
    useState(false);

  const devicesSearchFilters = getDevicesFilters();

  useEffect(() => {
    return () => {
      setRenderBulkDownloadMetadata(false);
      setRenderFilteredDownloadMetadata(false);
      setRenderBulkUpdateMetadata(false);
    };
  }, [isOpen]);

  return (
    <Modal open={isOpen} onClose={close} size="tiny" className="dark">
      <Modal.Header>Metadata Bulk Operations</Modal.Header>
      {!renderBulkDownloadMetadata &&
        !renderBulkUpdateMetadata &&
        !renderFilteredDownloadMetadata && (
          <Modal.Content>
            <Grid>
              <Grid.Row
                style={{
                  paddingBottom: "0px",
                }}
              >
                <Grid.Column
                  width={9}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <div
                    style={{
                      justifyContent: "flex-start",
                      fontSize: "16px",
                      fontWeight: 700,
                    }}
                  >
                    Bulk Download
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      marginBottom: "8px",
                    }}
                  >
                    Click here to download metadata for{" "}
                    {devicesSearchFilters ? "multiple" : "all"} devices
                  </div>
                </Grid.Column>
                <Grid.Column
                  width={7}
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  {(devicesSearchFilters?.stateFilters ||
                    devicesSearchFilters.metaDatafilters ||
                    selectedDevices.length > 0) && (
                    <StyledButtonWithBorder
                      onClick={() => setRenderFilteredDownloadMetadata(true)}
                      style={{
                        marginBottom: "10px",
                        fontSize: "13px",
                        width: "170px",
                      }}
                    >
                      <Icon name="cloud download" />{" "}
                      <span>Download Filtered</span>
                    </StyledButtonWithBorder>
                  )}
                  <StyledButtonWithBorder
                    onClick={() => setRenderBulkDownloadMetadata(true)}
                    style={{
                      fontSize: "13px",
                      width: "170px",
                    }}
                  >
                    <Icon name="cloud download" />{" "}
                    <span>Download Metadata</span>
                  </StyledButtonWithBorder>
                </Grid.Column>
              </Grid.Row>

              <ThinDivider />

              <Grid.Row
                style={{
                  padding: "0px",
                }}
              >
                <Grid.Column
                  width={9}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: 700,
                    }}
                  >
                    Bulk Update
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      marginBottom: "8px",
                    }}
                  >
                    Click here to update metadata for multiple devices in bulk
                  </div>
                </Grid.Column>
                <Grid.Column
                  width={7}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <StyledButtonWithBorder
                    onClick={() => setRenderBulkUpdateMetadata(true)}
                    style={{
                      fontSize: "13px",
                      width: "170px",
                    }}
                  >
                    <Icon name="cloud upload" /> <span>Update Metadata</span>
                  </StyledButtonWithBorder>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Content>
        )}
      {renderBulkDownloadMetadata && !renderBulkUpdateMetadata && (
        <DownloadMetadataModal
          close={() => setRenderBulkDownloadMetadata(false)}
        />
      )}
      {renderFilteredDownloadMetadata && !renderBulkUpdateMetadata && (
        <DownloadFilteredMetadataModal
          devicesSearchFilters={
            selectedDevices.length > 0
              ? { metaDatafilters: { id: selectedDevices } }
              : devicesSearchFilters
          }
          close={() => setRenderFilteredDownloadMetadata(false)}
        />
      )}
      {!renderBulkDownloadMetadata && renderBulkUpdateMetadata && (
        <BulkMetadataUpdateModal
          close={() => setRenderBulkUpdateMetadata(false)}
          refreshDevices={refreshDevices}
          isRefreshPaused={isRefreshPaused}
          setLoading={setLoading}
        />
      )}
    </Modal>
  );
}

export default BulkMetadataOperationsModal;
